import { type ReactNode } from 'react';
import { Transition } from 'react-transition-group';
import Media from 'react-media';

import { Portal } from '@simplywallst/ui-core';
import { useTheme } from '@simplywallst/ui-core';

import { Container, TransformerContainer, Dimmer } from './styled';

interface Props {
  children: ReactNode;
  show: boolean;
  close: () => void;
}

export const SideMenu = ({ children, show, close }: Props) => {
  const theme = useTheme();

  return (
    <Media query={{ maxWidth: theme.smMinRaw }}>
      {(matches) => {
        return (
          <Portal portalId="narrative-side-menu">
            <Transition
              timeout={{
                appear: 400,
                enter: 400,
                exit: 400,
              }}
              in={show}
            >
              {(state) => {
                if (state === 'exited') return null;
                return (
                  <>
                    <Container left={matches ? '0px' : 'auto'}>
                      <TransformerContainer
                        data-cy-id="side-menu-transformer-container"
                        timeout={400}
                        status={state}
                      >
                        {children}
                      </TransformerContainer>
                    </Container>
                    <Dimmer onClick={close} />
                  </>
                );
              }}
            </Transition>
          </Portal>
        );
      }}
    </Media>
  );
};
